"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTag = createTag;
exports["default"] = void 0;
exports.deleteTag = deleteTag;
exports.deleteTagFromProject = deleteTagFromProject;
exports.findTags = findTags;

var _api = _interopRequireWildcard(require("./api"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function createTag(tagData) {
  return _api["default"].put('/api/tag', tagData).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteTag(tagId) {
  return _api["default"]["delete"]("/api/tag/".concat(tagId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function findTags(query) {
  return _api["default"].get("/api/tag?q=".concat(query)).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteTagFromProject(tagId) {
  return _api["default"]["delete"]("/api/tag/".concat(tagId, "/project")).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  createTag: createTag,
  deleteTag: deleteTag,
  findTags: findTags,
  deleteTagFromProject: deleteTagFromProject
};
var _default = api;
exports["default"] = _default;